<!--
  Root template of the Provisionsmatrix OBC. Branches by view mode only — the exact shape of
  cp-provision-contract-agent-object.component.html. The `initialized && dto` guard is mandatory:
  no dto exists before that. `handleNavigationItems($event)` passes the Base component's navItems
  through to the frame's object navigation.

  'side' / 'mini-side' is the mode the inheritance-chain chip of the Beratersicht opens (left
  drawer), so it is the branch that carries the day-to-day traffic.
-->
@if (initialized && dto) {

    @if (uiMode == 'side' || uiMode == 'mini-side') {

        <cp-provision-type-matrix-side
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></cp-provision-type-matrix-side>

    } @else {

        <cp-provision-type-matrix-full
                [objectIdentifier]="objectIdentifier"
                [dto]="dto"
                [uiMode]="uiMode"
                (onNavigationItems)="handleNavigationItems($event)"
        ></cp-provision-type-matrix-full>

    }

}
